var _stop, _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCommentRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.686,
    x2: 35.58,
    y1: 4.592,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2196f3",
    style: {
      stopColor: "#9c9519",
      stopOpacity: 1
    }
  }), _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196f3"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 12.686,
    x2: 35.58,
    y1: 4.592,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2196f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196f3"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#2196f3",
      strokeWidth: 13.71105597,
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeMiterlimit: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      paintOrder: "normal"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M42 8H6a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h8v7.998c0 .891 1.077 1.337 1.707.707L24.412 38H42a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Z",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#2196f3",
      strokeWidth: 3.72976289,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal",
      strokeMiterlimit: 1
    },
    textAnchor: "none",
    transform: "matrix(5.4045 0 0 5.4045 -1.11 -23.274)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCommentRead);
export default __webpack_public_path__ + "static/media/status-comment-read.ea8e8c400765ab430ef37c8129c9073d.svg";
export { ForwardRef as ReactComponent };